module.exports = __webpack_public_path__ + "assets/media/lunch.e9c312b8.mp3";